import React from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';

interface PageSectionProps {
  bg?: string;
  className?: string;
  children: React.ReactNode;
}

const PageSection: React.FC<PageSectionProps> = ({ bg, className, children }) => {
  const sectionClassName = classNames(
    styles.pageSection,
    {
      [styles.grayBg]: bg === 'gray'
    },
    className
  );

  return (
    <div className={sectionClassName}>
      <div className={styles.contentWrapper}>{children}</div>
    </div>
  );
};

export default PageSection;
